import { render, staticRenderFns } from "./PatientPortalButtonField.vue?vue&type=template&id=06b278e3&scoped=true"
import script from "./PatientPortalButtonField.vue?vue&type=script&lang=ts"
export * from "./PatientPortalButtonField.vue?vue&type=script&lang=ts"
import style0 from "./PatientPortalButtonField.vue?vue&type=style&index=0&id=06b278e3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b278e3",
  null
  
)

export default component.exports